import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Slider from "react-slick";
import { Header } from "../Header";
import { Footer } from "../Footer";
import { ReactDialogBox } from "react-js-dialog-box";
import generatePDF from "./PDFscore";
import "react-js-dialog-box/dist/index.css";
import "../assets/ohs/admin.css";
import "../assets/ohs/driving.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
export const Noises = () => {
  const inputRef = useRef(null);
  const second = useRef();
  const third = useRef();
  const forth = useRef();
  const fifth = useRef();
  const sixth = useRef();
  const seven = useRef();
  const eight = useRef();
  const st2 = useRef();

  const { id } = useParams();
  const changeFavicon = (url) => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = url;
    }
  };
  const [name_9, setname_9] = useState(false);
  const [closeBox, setcloseBox] = useState(true);
  const [PdfcardImg, setPdfcardImg] = useState("");
  const [scoreCard, setscoreCard] = useState("");

  //Lesson 1
  const [istruefalse_1, setistruefalse_1] = useState(false);
  const [lesson1, setlesson1] = useState(true);
  const [section1_tab1, setsection1_tab1] = useState("Tab1");
  const [strokeDashArray_less1, setstrokeDashArray_less1] = useState(false);

  //Lesson 2
  const [istruefalse_2, setistruefalse_2] = useState(false);
  const [strokeDashArray_less2, setstrokeDashArray_less2] = useState(false);
  const [lesson2, setlesson2] = useState(false);
  const [section1_tab2, setsection1_tab2] = useState(false);
  const [Tab2_1, setTab2_1] = useState("Tab1");
  const [Tab2_2, setTab2_2] = useState(false);
  //Lesson 3
  const [istruefalse_3, setistruefalse_3] = useState(false);
  const [strokeDashArray_less3, setstrokeDashArray_less3] = useState(false);
  const [dot1, setdot1] = useState(false);
  const [dot2, setdot2] = useState(false);
  const [dot3, setdot3] = useState(false);
  const [lesson3, setlesson3] = useState(false);
  const [section1_tab3, setsection1_tab3] = useState(false);
  const [section3_content, setsection3_content] = useState(false);
  const [param_title3, setparam_title3] = useState("");
  const [title3, settitle3] = useState("");
  const [param3, setparam3] = useState("");
  //Lesson 4
  const [istruefalse_4, setistruefalse_4] = useState(false);
  const [strokeDashArray_less4, setstrokeDashArray_less4] = useState(false);
  const [lesson4, setlesson4] = useState(false);
  const [section1_tab4, setsection1_tab4] = useState(false);
  //Lesson 5
  const [istruefalse_5, setistruefalse_5] = useState(false);
  const [strokeDashArray_less5, setstrokeDashArray_less5] = useState(false);
  const [lesson5, setlesson5] = useState(false);
  const [section1_tab5, setsection1_tab5] = useState(false);
  //Lesson 6
  const [istruefalse_6, setistruefalse_6] = useState(false);
  const [strokeDashArray_less6, setstrokeDashArray_less6] = useState(false);
  const [lesson6, setlesson6] = useState(false);

  //Lesson 7
  const [istruefalse_7, setistruefalse_7] = useState(false);
  const [strokeDashArray_less7, setstrokeDashArray_less7] = useState(false);
  const [lesson7, setlesson7] = useState(false);
  const [Tab7_1, setTab7_1] = useState("Tab1");
  const [Tab7_2, setTab7_2] = useState(false);
  const [Tab7_3, setTab7_3] = useState(false);
  const [Tab7_4, setTab7_4] = useState(false);
  const [Tab7_5, setTab7_5] = useState(false);
  const [Tab7_6, setTab7_6] = useState(false);

  const [Tab77_1, setTab77_1] = useState("Tab1");
  const [Tab77_2, setTab77_2] = useState(false);
  const [Tab77_3, setTab77_3] = useState(false);

  //Lesson 8
  const [istruefalse_8, setistruefalse_8] = useState(false);
  const [strokeDashArray_less8, setstrokeDashArray_less8] = useState(false);
  const [lesson8, setlesson8] = useState(false);
  const [eight3, seteight3] = useState(false);
  const [eight2, seteight2] = useState(false);
  const [eight1, seteight1] = useState(false);

  //Lesson 9 Start
  const [leftmenu_bar, setleftmenu_bar] = useState(0);
  const [barwidth, setbarwidth] = useState(0);
  const [lesson9, setlesson9] = useState(false);
  const [sec_1, setsec_1] = useState(true);
  const [quizless_9_1, setquizless_9_1] = useState(false);
  const [quizless_9_2, setquizless_9_2] = useState(false);
  const [quizless_9_3, setquizless_9_3] = useState(false);
  const [quizless_9_4, setquizless_9_4] = useState(false);
  const [quizless_9_5, setquizless_9_5] = useState(false);
  const [less_5_finresult, setless_5_finresult] = useState(false);
  const [checkQ_9_1, setcheckQ_9_1] = useState("");
  const [isfirstquiz_9_1, setisfirstquiz_9_1] = useState(false);
  const [issetQuizAns_9_1_btn, setissetQuizAns_9_1_btn] = useState(false);
  const [isOpacity_9, setisOpacity_9] = useState(false);

  const [worngansQuiz_9_1, setworngansQuiz_9_1] = useState(false);
  const [rightansQuiz_9_1, setrightansQuiz_9_1] = useState(false);
  const [q1_9_next, setq1_9_next] = useState(false);
  const [checkbtn_quiz_1_9, setcheckbtn_quiz_1_9] = useState(false);

  const [isOpacity_9_1, setisOpacity_9_1] = useState(false);
  const [checkQ_9_2, setcheckQ_9_2] = useState(false);
  const [isfirstquiz_9_2, setisfirstquiz_9_2] = useState(false);
  const [issetQuizAns_9_2_btn, setissetQuizAns_9_2_btn] = useState(false);

  const [checkbtn_quiz_2_9, setcheckbtn_quiz_2_9] = useState(false);
  const [q2_9_next, setq2_9_next] = useState(false);

  const [checkQ_9_3, setcheckQ_9_3] = useState(false);
  const [isfirstquiz_9_3, setisfirstquiz_9_3] = useState(false);
  const [issetQuizAns_9_3_btn, setissetQuizAns_9_3_btn] = useState(false);

  const [checkbtn_quiz_3_9, setcheckbtn_quiz_3_9] = useState(false);
  const [q3_9_next, setq3_9_next] = useState(false);

  const [checkQ_9_4, setcheckQ_9_4] = useState(false);
  const [isfirstquiz_9_4, setisfirstquiz_9_4] = useState(false);
  const [issetQuizAns_9_4_btn, setissetQuizAns_9_4_btn] = useState(false);

  const [checkbtn_quiz_4_9, setcheckbtn_quiz_4_9] = useState(false);
  const [q4_9_next, setq4_9_next] = useState(false);

  const [checkQ_9_5, setcheckQ_9_5] = useState(false);
  const [isfirstquiz_9_5, setisfirstquiz_9_5] = useState(false);
  const [issetQuizAns_9_5_btn, setissetQuizAns_9_5_btn] = useState(false);

  const [checkbtn_quiz_5_9, setcheckbtn_quiz_5_9] = useState(false);
  const [q5_9_next, setq5_9_next] = useState(false);
  const [score__per5, setscore__per5] = useState([]);
  const [score_5, setscore_5] = useState([]);
  const [corrScore, setcorrScore] = useState(false);
  const [strokeDashArray_less9, setStrokeDashArray_less9] = useState("");
  const [istruefalse_9, setistruefalse_9] = useState(false);
  //Lesson 9 End
  useEffect(() => {
    const userStr = JSON.parse(localStorage.getItem("users"));

    if (userStr === null) {
      window.location.href = "/login";
    }
    changeFavicon(require("../assets/admin/images/f-icon.png"));

    document.title = "Start Course";

    if (scoreCard != "") {
      pdfdataget();
      setscoreCard("");
    }
  }, [id, scoreCard, PdfcardImg]);
  function formatDate_notes() {
    const options = {
      day: "2-digit",
      month: "long", // Change to "long" for full month name
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: "Australia/Perth",
    };

    const date = new Date();
    return date.toLocaleDateString("en-GB", options);
  }
  //Pdf
  function getimagedata(urll) {
    let formdata = {
      url: urll,
    };
    const imgBase64 =
      "data:image/png;base64,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";
    const mainpdf = (
      <html lang="en">
        <head>
          <meta charset="utf-8" />
          <link rel="icon" href="/" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="theme-color" content="#000000" />
          <meta
            name="description"
            content="Web site created using create-react-app"
          />
          <link
            href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Quattrocento:wght@400;700&display=swap"
            rel="stylesheet"
          />
        </head>
        <body>
          <table
            style={{
              width: "700px",
              margin: "0 auto",
              border: "10px solid rgb(0, 74, 173)",
            }}
          >
            <tbody style={{ width: "100%" }}>
              <tr>
                <td style={{ textAlign: "center" }}>
                  <div
                    style={{
                      margin: "0 auto",
                      width: "250px",
                    }}
                  >
                    <img style={{ width: "50%" }} src={imgBase64} alt="logo" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h1
                    style={{
                      color: "rgb(0, 74, 173)",
                      fontSize: "35px",
                      textAlign: "center",
                      padding: "0px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    Certificate of Training
                  </h1>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      fontSize: "20px",
                      textAlign: "center",
                      padding: "5px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    This is to certify that
                  </h2>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <h3
                      style={{
                        color: "#323232",
                        fontWeight: 400,
                        marginTop: "30px",
                        fontSize: "20px",
                        textAlign: "center",
                        padding: "5px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      {name_9}
                    </h3>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      marginTop: "30px",
                      fontSize: "20px",
                      textAlign: "center",
                      padding: "5px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    has successfully completed training in
                  </h2>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <h3
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "12px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      Noise Awareness
                    </h3>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div
                    style={{
                      padding: "10px 0px",
                      marginTop: "15px",
                    }}
                  >
                    <h5
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "0px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      undertaken on the date
                    </h5>
                    <h6
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "0px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      {formatDate_notes()}
                    </h6>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      fontSize: "20px",
                      textAlign: "center",
                      paddingTop: "40px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    Delivered by:
                  </h2>
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>
                  <div
                    style={{
                      margin: "0 auto",
                      width: "250px",
                      paddingBottom: "10px",
                    }}
                  >
                    <img style={{ width: "50%" }} src={imgBase64} alt="logo" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </body>
      </html>
    );
    const filenamee = "Noise Awareness";

    setTimeout(() => {
      generatePDF(mainpdf, filenamee);
    }, 500);
  }
  const pdfdataget = async () => {
    const cc = await getimagedata("logo1.png");
  };
  const downloadpdf = () => {
    const userStr = JSON.parse(localStorage.getItem("users"));

    let formdata = {
      user_id: userStr[0].id,
      id: id,
      name: name_9,
    };
    console.log(formdata);
    //setscoreCard(1);

    axios
      .post("https://jlmining.app/coursepdf", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => { })
      .catch((err) => { });
    pdfdataget();
  };
  //Pdf

  var settings_4 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  //Lesson9
  const entername_9 = (event) => {
    const trimmedValue = event.target.value.trim();
    if (trimmedValue === "") {
      setname_9(false);
    } else {
      setname_9(trimmedValue);
    }
  };
  const btn_entername = () => {
    if (name_9 !== false) {
      setquizless_9_1(true);
      setsec_1(false);
    }
  };
  const startQuiz_9_1 = (event) => {
    setcheckQ_9_1(event);
    setcheckbtn_quiz_1_9(true);
  };

  const startQuiz_9_2 = (event) => {
    setcheckQ_9_2(event);
    setcheckbtn_quiz_2_9(true);
  };
  const startQuiz_9_3 = (event) => {
    setcheckQ_9_3(event);
    setcheckbtn_quiz_3_9(true);
    setworngansQuiz_9_1(false);
    setrightansQuiz_9_1(false);
  };
  const startQuiz_9_4 = (event) => {
    setcheckQ_9_4(event);
    setcheckbtn_quiz_4_9(true);
    setworngansQuiz_9_1(false);
    setrightansQuiz_9_1(false);
  };
  const startQuiz_9_5 = (event) => {
    setcheckQ_9_5(event);
    setcheckbtn_quiz_5_9(true);
    setworngansQuiz_9_1(false);
    setrightansQuiz_9_1(false);
  };
  const Quiz_check_9 = (event) => {
    if (event === "1") {
      setisOpacity_9(true);
      if (checkQ_9_1 === "Decibels") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_9_1(true);
        setworngansQuiz_9_1(false);
      } else {
        setworngansQuiz_9_1(true);
        setrightansQuiz_9_1(false);
      }
      setissetQuizAns_9_1_btn("Decibels");
      setisfirstquiz_9_1(true);
      setq1_9_next(true);
      setcheckbtn_quiz_1_9(false);
      setcheckQ_9_1("");
      setStrokeDashArray_less9(200.39);
    }
    if (event === "2") {
      setisOpacity_9(true);
      if (checkQ_9_2 === "Hearing protection") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_9_1(true);
        setworngansQuiz_9_1(false);
      } else {
        setworngansQuiz_9_1(true);
        setrightansQuiz_9_1(false);
      }
      setissetQuizAns_9_2_btn("Hearing protection");
      setisfirstquiz_9_2(true);
      setq2_9_next(true);
      setcheckbtn_quiz_2_9(false);
      setcheckQ_9_2("");
      setStrokeDashArray_less9(300.39);
    }
    if (event === "3") {
      setisOpacity_9(true);
      if (checkQ_9_3 === "Reduce") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_9_1(true);
        setworngansQuiz_9_1(false);
      } else {
        setworngansQuiz_9_1(true);
        setrightansQuiz_9_1(false);
      }
      setissetQuizAns_9_3_btn("Reduce");
      setisfirstquiz_9_3(true);
      setq3_9_next(true);
      setcheckbtn_quiz_3_9(false);
      setcheckQ_9_3("");
      setStrokeDashArray_less9(350.39);
    }
    if (event === "4") {
      setisOpacity_9(true);
      if (checkQ_9_4 === "Wear") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_9_1(true);
        setworngansQuiz_9_1(false);
      } else {
        setworngansQuiz_9_1(true);
        setrightansQuiz_9_1(false);
      }
      setissetQuizAns_9_4_btn("Wear");
      setisfirstquiz_9_4(true);
      setq4_9_next(true);
      setcheckbtn_quiz_4_9(false);
      setcheckQ_9_4("");
      setStrokeDashArray_less9(400.39);
    }
    if (event === "5") {
      setisOpacity_9(true);
      if (checkQ_9_5 === "A ringing") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_9_1(true);
        setworngansQuiz_9_1(false);
      } else {
        setworngansQuiz_9_1(true);
        setrightansQuiz_9_1(false);
      }
      setissetQuizAns_9_5_btn("A ringing");
      setisfirstquiz_9_5(true);
      setq5_9_next(true);
      setcheckbtn_quiz_5_9(false);
      setcheckQ_9_5("");

      setistruefalse_9(true);
      setStrokeDashArray_less9(458.39);
    }
  };
  const Quiz_next_9 = (event) => {
    setworngansQuiz_9_1(false);
    setrightansQuiz_9_1(false);
    if (event === "1") {
      setquizless_9_2(true);
      setquizless_9_1(false);
      setcheckbtn_quiz_1_9(false);
    }
    if (event === "2") {
      setquizless_9_3(true);
      setquizless_9_2(false);
      setrightansQuiz_9_1(false);
      setcheckbtn_quiz_2_9(false);
    }
    if (event === "3") {
      setquizless_9_4(true);
      setquizless_9_3(false);
      setcheckbtn_quiz_3_9(false);
    }
    if (event === "4") {
      setquizless_9_5(true);
      setquizless_9_4(false);
      setcheckbtn_quiz_4_9(false);
    }
    if (event === "5") {
      setquizless_9_5(false);
      setless_5_finresult(true);
      setleftmenu_bar(100);
      setbarwidth(100);
      setleftmenu_bar(100);
      setbarwidth(100);
      const sum = score_5.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      const sum_per = score__per5.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      setscore_5(sum);
      setscore__per5(sum_per);
      if (sum_per >= 80) {
        setcorrScore(true);
      }
    }
  };
  const refreshbtn = (event) => {
    console.log("ss");
    setless_5_finresult(false);
    setsec_1(true);
    setname_9(false);
    setquizless_9_1(false);
    setquizless_9_2(false);
    setquizless_9_3(false);
    setquizless_9_4(false);
    setquizless_9_5(false);

    setcheckQ_9_1("");
    setisfirstquiz_9_1(false);
    setissetQuizAns_9_1_btn(false);
    setisOpacity_9(false);
    setworngansQuiz_9_1(false);
    setrightansQuiz_9_1(false);
    setq1_9_next(false);
    setcheckbtn_quiz_1_9(false);
    setisOpacity_9_1(false);
    setcheckQ_9_2(false);
    setisfirstquiz_9_2(false);
    setissetQuizAns_9_2_btn(false);
    setcheckbtn_quiz_2_9(false);
    setq2_9_next(false);
    setcheckQ_9_3(false);
    setisfirstquiz_9_3(false);
    setissetQuizAns_9_3_btn(false);
    setcheckbtn_quiz_3_9(false);
    setq3_9_next(false);
    setcheckQ_9_4(false);
    setisfirstquiz_9_4(false);
    setissetQuizAns_9_4_btn(false);
    setcheckbtn_quiz_4_9(false);
    setq4_9_next(false);
    setcheckQ_9_5(false);
    setisfirstquiz_9_5(false);
    setissetQuizAns_9_5_btn(false);
    setcheckbtn_quiz_5_9(false);
    setq5_9_next(false);
    setscore__per5([]);
    setscore_5([]);
    setcorrScore(false);
    setStrokeDashArray_less9("");
    setistruefalse_9(false);
  };
  //Lesson9

  const menubars = () => {
    setcloseBox(!closeBox);
  };

  const nextstep = (event) => {
    if (event === "1") {
      setistruefalse_1(true);
      setstrokeDashArray_less1(458.36);
      setlesson1(false);
      setlesson2(true);
      setleftmenu_bar(12);
      setbarwidth(12);
      setTimeout(() => {
        second.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "2") {
      setistruefalse_2(true);
      setstrokeDashArray_less2(458.36);
      setlesson2(false);
      setlesson3(true);
      setleftmenu_bar(24);
      setbarwidth(24);
      setTimeout(() => {
        third.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "3") {
      setistruefalse_3(true);
      setstrokeDashArray_less3(458.36);
      setlesson3(false);
      setlesson4(true);
      setleftmenu_bar(36);
      setbarwidth(36);
      setTimeout(() => {
        forth.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "4") {
      setistruefalse_4(true);
      setstrokeDashArray_less4(458.36);
      setlesson4(false);
      setlesson5(true);
      setleftmenu_bar(50);
      setbarwidth(50);
      setTimeout(() => {
        fifth.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "5") {
      setistruefalse_5(true);
      setstrokeDashArray_less5(458.36);
      setlesson5(false);
      setlesson6(true);
      setleftmenu_bar(62);
      setbarwidth(62);
      setTimeout(() => {
        sixth.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "6") {
      setistruefalse_6(true);
      setstrokeDashArray_less6(458.36);
      setlesson6(false);
      setlesson7(true);
      setleftmenu_bar(74);
      setbarwidth(74);
      setTimeout(() => {
        seven.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "7") {
      setistruefalse_7(true);
      setstrokeDashArray_less7(458.36);
      setlesson7(false);
      setlesson8(true);
      setleftmenu_bar(82);
      setbarwidth(82);
      setTimeout(() => {
        eight.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "8") {
      setistruefalse_8(true);
      setstrokeDashArray_less8(458.36);
      setlesson8(false);
      setlesson9(true);
      setleftmenu_bar(90);
      setbarwidth(90);
    }
  };

  //Lesson1
  const tabsection1 = (event) => {
    setsection1_tab5(false);
    setsection1_tab4(false);
    setsection1_tab3(false);
    setsection1_tab2(false);
    setsection1_tab1(false);
    if (event === "Tab1") {
      setsection1_tab1(true);
    }
    if (event === "Tab2") {
      setsection1_tab2(true);
    }
    if (event === "Tab3") {
      setsection1_tab3(true);
    }
    if (event === "Tab4") {
      setsection1_tab4(true);
    }
    if (event === "Tab5") {
      setsection1_tab5(true);
    }
  };

  //Lesson 2
  const tabsection2 = (event) => {
    setTab2_1(false);
    setTab2_2(false);
    if (event === "Tab1") {
      setTab2_1(event);
    }
    if (event === "Tab2") {
      setTab2_2(event);
    }
  };

  //Lesson 3
  const bodypart = (event) => {
    if (event === "1") {
      setdot2(false);
      setdot3(false);
      setdot1(!dot1);
      console.log(dot1);
      if (dot1 === true) {
        setsection3_content(false);
      } else {
        setsection3_content(true);
      }
      settitle3("Ear Canal");
      setparam_title3("Ear Canal");
      setparam3(
        "The ear canal is a pathway running from the outer ear to the middle ear "
      );
    }
    if (event === "2") {
      setdot1(false);
      setdot3(false);
      setdot2(!dot2);
      if (dot2 === true) {
        setsection3_content(false);
      } else {
        setsection3_content(true);
      }
      settitle3("Malleus");
      setparam_title3("Malleus ");
      setparam3(
        " The malleus or hammer is a hammer-shaped small bone in the middle ear.The malleus transmits the sound vibrations from the eardrum to the incus."
      );
    }
    if (event === "3") {
      setdot1(false);
      setdot2(false);
      setdot3(!dot3);
      if (dot3 === true) {
        setsection3_content(false);
      } else {
        setsection3_content(true);
      }
      settitle3("Eardrum");
      setparam_title3("Eardrum");
      setparam3(
        " The eardrum is a thin membrane that separates the ear canal from the middle ear. The eardrum, also called the tympanic membrane, is involved in hearing. "
      );
    }
  };

  //Lesson 7
  const tabsection7 = (event) => {
    setTab7_1(false);
    setTab7_2(false);
    setTab7_3(false);
    setTab7_4(false);
    setTab7_5(false);
    setTab7_6(false);
    if (event === "Tab1") {
      setTab7_1(true);
    }
    if (event === "Tab2") {
      setTab7_2(event);
    }
    if (event === "Tab3") {
      setTab7_3(event);
    }
    if (event === "Tab4") {
      setTab7_4(event);
    }
    if (event === "Tab5") {
      setTab7_5(event);
    }
    if (event === "Tab6") {
      setTab7_6(event);
    }
  };
  const tabsection7_3 = (event) => {
    setTab77_1(false);
    setTab77_2(false);
    setTab77_3(false);
    if (event === "Tab1") {
      setTab77_1(event);
    }
    if (event === "Tab2") {
      setTab77_2(event);
    }
    if (event === "Tab3") {
      setTab77_3(event);
    }
  };
  //Lesson 8
  const section8 = (event) => {
    if (event === "1") {
      seteight1(!eight1);
    }
    if (event === "2") {
      seteight2(!eight2);
    }
    if (event === "3") {
      seteight3(!eight3);
    }
  };

  const backlesson = (event) => {
    if (event === "2") {
      setlesson2(false);
      setlesson1(true);
    }
    if (event === "3") {
      setlesson3(false);
      setlesson2(true);
    }
    if (event === "4") {
      setlesson4(false);
      setlesson3(true);
    }
    if (event === "5") {
      setlesson5(false);
      setlesson4(true);
    }
    if (event === "6") {
      setlesson6(false);
      setlesson5(true);
    }
    if (event === "7") {
      setlesson7(false);
      setlesson6(true);
    }
    if (event === "8") {
      setlesson8(false);
      setlesson7(true);
    }
    if (event === "9") {
      setlesson9(false);
      setlesson8(true);
    }
  };
  return (
    <>
      <div
        className={`d-flex main-admin-block align-items-stretch mt-4 ${closeBox ? "" : "close-box"
          }`}
      >
        <div className="flex-shrink-0 side-layer">
          <div className="scroll-height">
            <div className="d-flex flex-column">
              <div className="top-title d-flex flex-column gap-5">
                <h1>Noise Awareness</h1>
                <div className="d-flex flex-column gap-1">
                  <div className="progress-bar-full">
                    <div style={{ width: `${barwidth}%` }}></div>
                  </div>
                  <h4 className="pro-number">
                    <span>{leftmenu_bar}%</span> COMPLETE
                  </h4>
                </div>
              </div>

              <div className="d-flex flex-column side-navbar mt-4">
                <Link
                  to="noise.html"
                  className="d-flex align-items-center gap-3 list-link anilink"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Introduction</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_1 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_1 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less1 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Legislation</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_2 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_2 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less2 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>The Ear</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_3 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_3 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less3 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Noise-induced Hearing Loss(NIHL)</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_4 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_4 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less4 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Noise Exposure Standards</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_5 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_5 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less5 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Assessment of Noise Levels</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_6 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_6 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less6 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Noise Control and Management </h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_7 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_7 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less7 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Personal Protective Equipment</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_8 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_8 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less8 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Final Assessment</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_9 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_9 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less9 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-grow-1 rightpart">
          {lesson1 && (
            <section id="introd" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  to={`/start-course/${id}`}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Home</h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 1 of 9</h4>
                      <h1>Introduction</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>

                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <h5>What Is Noise?</h5>
                      <div className="row align-items-center ">
                        <div className="col-lg-6">
                          <div className="d-block">
                            <img
                              className="w-100"
                              src={require("../assets/ohs/images/noise-img/img1.jpg")}
                              alt="img"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="d-block">
                            <p>
                              Noise is defined as any unwanted sound judged to
                              be unpleasant, loud or disruptive to hearing.
                            </p>
                            <p>
                              Noise that is considered hazardous can destroy the
                              ability to hear clearly and can also make it more
                              difficult to hear the sounds necessary for working
                              safely, such as instructions or warning signals.
                            </p>
                            <p>
                              Managing the risks related to noise will assist
                              in:
                            </p>
                            <ul className="d-flex flex-column gap-3">
                              <li>
                                <p>
                                  Protecting workers from hearing loss and
                                  disabling tinnitus (ringing in the ears or
                                  head).
                                </p>
                              </li>
                              <li>
                                <p>
                                  Improving the conditions for communication and
                                  hearing warning sounds.
                                </p>
                              </li>
                              <li>
                                <p>
                                  Creating a less stressful and more productive
                                  work environment
                                </p>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <h5>How Is Noise Measured?</h5>
                      <p>
                        To assess noise levels, a sound level meter is employed,
                        quantifying noise intensity in decibel units (dB).
                      </p>
                      <div className="row align-items-center ">
                        <div className="col-lg-6">
                          <div className="d-block">
                            <img
                              className="w-100"
                              src={require("../assets/ohs/images/noise-img/img2.jpg")}
                              alt="img"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="d-block">
                            <p>
                              On the decibel scale, the faintest audible sound
                              (approaching total silence) registers at 0 dB. A
                              sound tenfold more potent than near-total silence
                              corresponds to 10 dB, while a sound exhibiting a
                              hundredfold increase is rated at 20 dB. This
                              pattern continues, with each subsequent increment
                              of 10 representing a tenfold increase in sound
                              intensity.
                            </p>
                          </div>
                        </div>
                      </div>
                      <p>
                        Decibels operate differently from conventional numbers;
                        they don't adhere to regular arithmetic rules due to
                        their logarithmic nature. In this scale, a 3 dB rise
                        signifies a doubling of sound energy. Consequently,
                        every 3 dB augmentation in noise level can potentially
                        halve the duration required to inflict similar damage to
                        an individual's hearing.
                      </p>
                      <h5>Weighting</h5>
                      <p>
                        In addition to the numerical noise level, there are
                        appended letters indicating the nature or duration of
                        the noise measurement:
                      </p>
                      <ul className="d-flex flex-column gap-3 ">
                        <li>
                          <p>
                            A weighting (LAeq) — typical for continuous sound
                            exposure, such as 43 dB(A).
                          </p>
                        </li>
                        <li>
                          <p>
                            C weighting (LC,peak) — suitable for short-term
                            assessments of impact noise, like 43 dB(C).
                          </p>
                        </li>
                        <li>
                          <p>
                            Daily averaging (LAeq,8h) — factors in daily
                            variations in noise exposure over an 8-hour workday.
                          </p>
                        </li>
                        <li>
                          <p>
                            Weekly averaging — applicable when elevated noise
                            levels occur sporadically, perhaps only on a couple
                            of days during a workweek.
                          </p>
                        </li>
                      </ul>
                      <h5>What are the Risks Associated with Noise?</h5>
                      <p>
                        Noise constitutes a regular aspect of daily life;
                        however, prolonged or sudden exposure to high noise
                        levels can lead to permanent hearing damage.
                      </p>
                      <p>Consequences of noise exposure may include:</p>
                      <div className="py-3 d-flex justify-content-center align-items-center bg-light">
                        <div
                          className="card1 card-1 p-0 shadow"
                          style={{ maxWidth: "100%" }}
                        >
                          <nav>
                            <div
                              className="nav nav-tabs mb-3 nav-fill"
                              id="nav-tab1"
                              role="tablist"
                            >
                              <button
                                className={`nav-link  ${section1_tab1 === "Tab1" ? "active " : ""
                                  } `}
                                id="nav-home-tab1"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-home1"
                                type="button"
                                role="tab"
                                aria-controls="nav-home"
                                aria-selected="false"
                                tabindex="-1"
                                onClick={() => tabsection1("Tab1")}
                              >
                                Noise Induced Hearing Loss
                              </button>
                              <button
                                className={`nav-link  ${section1_tab2 === "Tab2" ? "active " : ""
                                  } `}
                                id="nav-profile-tab2"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-profile2"
                                type="button"
                                role="tab"
                                aria-controls="nav-profile"
                                aria-selected="false"
                                tabindex="-1"
                                onClick={() => tabsection1("Tab2")}
                              >
                                Tinnitus
                              </button>
                              <button
                                className={`nav-link  ${section1_tab3 === "Tab3" ? "active " : ""
                                  } `}
                                id="nav-contact-tab3"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-contact3"
                                type="button"
                                role="tab"
                                aria-controls="nav-contact"
                                aria-selected="true"
                                onClick={() => tabsection1("Tab3")}
                              >
                                Stress
                              </button>
                              <button
                                className={`nav-link  ${section1_tab4 === "Tab4" ? "active " : ""
                                  } `}
                                id="nav-green-tab4"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-green4"
                                type="button"
                                role="tab"
                                aria-controls="nav-green4"
                                aria-selected="false"
                                tabindex="-1"
                                onClick={() => tabsection1("Tab4")}
                              >
                                Temporary Threshold Shif
                              </button>
                              <button
                                className={`nav-link  ${section1_tab5 === "Tab5" ? "active " : ""
                                  } `}
                                id="nav-red-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-red"
                                type="button"
                                role="tab"
                                aria-controls="nav-red"
                                aria-selected="false"
                                tabindex="-1"
                                onClick={() => tabsection1("Tab5")}
                              >
                                Peripheral Devices
                              </button>
                            </div>
                          </nav>
                          <div
                            className="tab-content p-4 bg-light"
                            id="nav-tabContent"
                          >
                            {section1_tab1 && (
                              <div
                                className="tab-pane fade active show"
                                id="nav-home1"
                                role="tabpanel"
                                aria-labelledby="nav-home-tab1"
                              >
                                <p>
                                  Continuous exposure to excessive noise in the
                                  workplace can lead to noise-induced hearing
                                  loss (NIHL) among workers. Hearing damage can
                                  result from either prolonged exposure to
                                  continuous noise or from brief bursts of
                                  high-energy noise. However, it's not just
                                  industrial settings where workers face
                                  elevated noise levels. For instance, nursery
                                  schools often maintain noise levels averaging
                                  over 85 dB, while truck drivers can be exposed
                                  to around 89 dB.
                                </p>
                                <p>
                                  Typically, hearing loss due to NIHL develops
                                  gradually over many years. Because of this
                                  slow onset, individuals may not immediately
                                  recognize their deteriorating hearing.
                                  Nevertheless, there are instances of sudden,
                                  high-level impulsive noise sources such as
                                  explosions or gunfire that can cause immediate
                                  damage to the unprotected ear.
                                </p>
                                <p>
                                  Often, individuals may not perceive the
                                  effects of NIHL until years after their
                                  initial exposure to loud noise. Some
                                  individuals may first notice symptoms like
                                  tinnitus, indicating potential damage to their
                                  hearing caused by noise.
                                </p>
                              </div>
                            )}
                            {section1_tab2 && (
                              <div
                                className="tab-pane fade active show"
                                id="nav-profile2"
                                role="tabpanel"
                                aria-labelledby="nav-profile-tab2"
                              >
                                <p>
                                  Tinnitus is the sensation of sound that
                                  originates internally and is not triggered by
                                  an external source. It can manifest in one or
                                  both ears, within the head, or within the
                                  immediate surroundings of the individual.
                                  Tinnitus can present itself as ringing,
                                  hissing, whistling, humming, buzzing, or
                                  clicking noises, with pitches ranging from low
                                  roars to high squeals. The experience of
                                  tinnitus may be sporadic, or it may persist as
                                  a constant or uninterrupted sound.
                                </p>
                              </div>
                            )}
                            {section1_tab3 && (
                              <div
                                className="tab-pane fade active show"
                                id="nav-contact3"
                                role="tabpanel"
                                aria-labelledby="nav-contact-tab3"
                              >
                                <p>
                                  Loud sounds and extended exposure to specific
                                  noises can elicit physiological stress
                                  reactions within our bodies, including
                                  increases in blood pressure and heart rate.
                                  Studies indicate that even sporadic exposure
                                  to loud noises can contribute to elevated
                                  long-term stress levels and hypertension.
                                </p>
                              </div>
                            )}
                            {section1_tab4 && (
                              <div
                                className="tab-pane fade active show"
                                id="nav-green4"
                                role="tabpanel"
                                aria-labelledby="nav-green-tab4"
                              >
                                <p>
                                  Sturdy and permits users to move freely while
                                  maintaining a comfortable position. The chair
                                  should have height adjustment capability. Both
                                  the height and tilt of the chair back must be
                                  adjustable. A footrest should be provided upon
                                  request to accommodate any user.
                                </p>
                              </div>
                            )}
                            {section1_tab5 && (
                              <div
                                className="tab-pane fade active show"
                                id="nav-red"
                                role="tabpanel"
                                aria-labelledby="nav-red-tab"
                              >
                                <p>
                                  A temporary threshold shift, leading to a
                                  temporary hearing impairment, typically arises
                                  from exposure to intense or loud sounds or
                                  noise, whether for a brief or extended
                                  duration. For instance, instances like an
                                  explosion or attending a concert can trigger
                                  such shifts.
                                </p>
                                <p>
                                  If adequate recovery time is not afforded
                                  before further exposure to sound, the damage
                                  can transition into a permanent condition. The
                                  duration needed to recuperate from a temporary
                                  threshold shift varies; symptoms may diminish
                                  within minutes to hours, but it could take
                                  days for them to completely vanish.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <h5>
                        What Impact Does Noise Exposure Have on Your Hearing?
                      </h5>
                      <p>
                        Noise-induced hearing loss often manifests as a decline
                        in hearing sensitivity, particularly in the higher
                        frequencies, making it challenging to perceive these
                        pitches compared to others. With sustained noise
                        exposure, this hearing impairment can extend to
                        encompass lower and higher frequencies as well. As it
                        progresses and affects a broader frequency range,
                        difficulty in following conversations, especially in
                        noisy environments, becomes increasingly apparent.
                        Eventually, individuals may struggle to understand
                        speech even in quiet settings, indicating the
                        progressive nature of noise-induced hearing loss.
                      </p>
                      <p>
                        Excessive exposure to intense and traumatic sounds can
                        accelerate the natural aging process, leading to early
                        development of hearing loss. As a result, individuals in
                        their 40s or 50s may experience a level of hearing
                        impairment comparable to that of someone who is 90 years
                        old.
                      </p>
                    </div>
                    <div className="d-block padding btn-block text-center">
                      <button type="button" onClick={() => nextstep("1")}>
                        CONTINUE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson2 && (
            <section id="legislation" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={second}
                  onClick={() => backlesson("2")}
                  to="#introd"
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson - 1 Introduction</h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 2 of 9</h4>
                      <h1>Legislation</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>

                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <p>
                        The Work, Health and Safety Act, along with its
                        accompanying regulations, imposes a series of
                        obligations on persons conducting a business or
                        undertaking (PCBUs) to uphold the health and safety of
                        workers and others within the workplace.
                      </p>
                      <p>
                        Regarding noise within the workplace, a PCBU must ensure
                        that individuals at work are not exposed to noise levels
                        that, as measured in accordance with AS/NZS 1269.1 -
                        2005 Occupational noise management - Measurement and
                        assessment of noise emission and exposure, meet the
                        following criteria:
                      </p>
                      <ul className="d-flex flex-column gap-3">
                        <li>
                          <p>
                            Equivalent to or surpassing 85 dB(A) over an 8-hour
                            shift (LAeq,8h).
                          </p>
                        </li>
                        <li>
                          <p>
                            Peak noise levels exceeding 140 dB(C) (LC,peak).
                          </p>
                        </li>
                      </ul>
                      <p>
                        The exposure standard of 85 dB(A) averaged over eight
                        hours signifies daily noise exposure levels at which
                        most individuals are unlikely to suffer significant
                        noise-induced hearing loss (NIHL) over a lifetime of
                        employment. However, due to variations in individual
                        susceptibility to NIHL, some individuals remain at risk
                        of hearing damage from daily exposure levels below the
                        standard.
                      </p>
                      <p>
                        Thus, it is recommended for PCBUs to endeavor to
                        minimize occupational noise exposure levels to the
                        lowest reasonably achievable level and to conduct
                        ongoing monitoring of workers' hearing through regular
                        audiometric testing.
                      </p>
                      <p>
                        Nevertheless, different states and territories have
                        adopted varied approaches to mandating audiometric
                        testing, even among those operating under harmonized
                        health and safety legislation, as outlined in the table
                        below.
                      </p>
                      <table className="customTable">
                        <thead>
                          <tr>
                            <th style={{ color: "#fff" }}>
                              <h3>State / Territory</h3>
                            </th>
                            <th style={{ color: "#fff" }}>
                              <h3>Audiometric Testing Requirement</h3>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <p> New South Wales</p>
                            </td>
                            <td>
                              <p>
                                Testing required within 3 months of workers
                                starting, then at least every 2 years once
                                exemption ends.
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>Victoria </p>
                            </td>
                            <td>
                              <p>
                                Testing required within 3 months of employees
                                starting, then at least every 2 years for
                                employees who frequently use hearing protection
                                to control exposure.
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>Queensland</p>
                            </td>
                            <td>
                              <p>No requirement for testing.</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>Tasmania</p>
                            </td>
                            <td>
                              <p>
                                Testing required within 3 months of worker
                                starting, then at least every 2 years for
                                workers who frequently use hearing protection to
                                control exposure.
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>South Australia</p>
                            </td>
                            <td>
                              <p>
                                Testing required within 3 months of worker
                                starting, then at least every 2 years for
                                workers who frequently use hearing protection to
                                control exposure.
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>Australian Capital Territory</p>
                            </td>
                            <td>
                              <p>
                                Testing required within 3 months of worker
                                starting, then at least every 2 years for
                                workers who frequently use hearing protection to
                                control exposure.
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>Western Australia</p>
                            </td>
                            <td>
                              <p>
                                Testing required within 3 months of worker
                                starting, then at least every 2 years once
                                exemption ends.
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <p>
                        For the states and territories where audiometry is
                        mandated, more frequent audiometric testing is
                        recommended where the equivalent 8-hour exposure is
                        equal to or greater than
                      </p>
                      <div className="py-3 d-flex justify-content-center align-items-center bg-light">
                        <div
                          className="card1 card-1 p-0 shadow"
                          style={{ maxWidth: "100%" }}
                        >
                          <nav>
                            <div
                              className="nav nav-tabs mb-3 nav-fill"
                              id="nav-tab1"
                              role="tablist"
                            >
                              <button
                                className={`nav-link  ${Tab2_1 === "Tab1" ? "active " : ""
                                  } `}
                                id="nav-home-tab11"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-home11"
                                type="button"
                                role="tab"
                                aria-controls="nav-home"
                                aria-selected="true"
                                onClick={() => tabsection2("Tab1")}
                              >
                                PCBU’S DUTIES
                              </button>
                              <button
                                className={`nav-link  ${Tab2_2 === "Tab2" ? "active " : ""
                                  } `}
                                id="nav-profile-tab21"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-profile21"
                                type="button"
                                role="tab"
                                aria-controls="nav-profile"
                                aria-selected="false"
                                tabindex="-1"
                                onClick={() => tabsection2("Tab2")}
                              >
                                Long–Term Injuries
                              </button>
                            </div>
                          </nav>
                          <div
                            className="tab-content p-4 bg-light"
                            id="nav-tabContent"
                          >
                            {Tab2_1 && (
                              <div
                                className="tab-pane fade active show"
                                id="nav-home11"
                                role="tabpanel"
                                aria-labelledby="nav-home-tab11"
                              >
                                <div className="d-flex flex-column gap-3">
                                  <p>Organizations are required to:</p>
                                  <ul className="d-flex flex-column gap-3">
                                    <li>
                                      <p>
                                        Identify noise hazards present in the
                                        workplace.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        Estimate potential noise exposures of
                                        workers.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        Determine necessary measures to
                                        eliminate or minimize risks, control
                                        exposures, and safeguard workers.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        Document these measures in an action
                                        plan.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        Enforce the mandatory use of hearing
                                        protection for workers in high-risk
                                        scenarios.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        Educate, inform, and train workers about
                                        noise-related risks, control measures,
                                        proper use of hearing protection, and
                                        safe work practices.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        Offer health monitoring, including
                                        regular hearing checks, for individuals
                                        at risk.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        Maintain and upkeep noise control
                                        equipment and hearing protection to
                                        effectively manage exposure.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        Regularly monitor and review the
                                        implemented control measures within the
                                        workplace to ensure effectiveness.
                                      </p>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}
                            {Tab2_2 && (
                              <div
                                className="tab-pane fade active show"
                                id="nav-profile21"
                                role="tabpanel"
                                aria-labelledby="nav-profile-tab21"
                              >
                                <div className="d-flex flex-column gap-3">
                                  <p>
                                    According to the regulations, workers are
                                    obligated to:
                                  </p>
                                  <ul className="d-flex flex-column gap-3">
                                    <li>
                                      <p>
                                        Exercise reasonable care concerning
                                        their own health and safety, as well as
                                        that of others impacted by their work.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        Utilize any provided control measures to
                                        manage exposure to noise and promptly
                                        report any deficiencies in such
                                        measures.
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        Participate in audiometric testing as
                                        necessary, ensuring availability during
                                        working hours.
                                      </p>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-block padding btn-block text-center">
                      <button type="button" onClick={() => nextstep("2")}>
                        CONTINUE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson3 && (
            <section id="ear" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={third}
                  onClick={() => backlesson("3")}
                  to="#legislation"
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson - 2 The Ear</h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 3 of 9</h4>
                      <h1>The Ear</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>

                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <p>
                        To gain a comprehensive understanding of how noise
                        exposure impacts the body, it's essential to grasp the
                        functioning of the ear and its conversion of sound waves
                        into electrical impulses.
                      </p>
                      <h5>The Human Ear</h5>
                      <p>
                        The peripheral hearing system comprises three main
                        components: the outer ear, the middle ear, and the inner
                        ear.
                      </p>
                      <ul className="d-flex flex-column gap-3">
                        <li>
                          <p>
                            The outer ear includes the pinna (or auricle), ear
                            canal, and eardrum.
                          </p>
                        </li>
                        <li>
                          <p>
                            The middle ear is a small, air-filled cavity housing
                            three minuscule bones known as the ossicles
                            (comprising the malleus, incus, and stapes). The
                            malleus connects to the eardrum, linking it to the
                            outer ear, while the stapes connects to the inner
                            ear.
                          </p>
                        </li>
                        <li>
                          <p>
                            The inner ear encompasses both the organs
                            responsible for hearing and balance. The hearing
                            component, known as the cochlea, derives its name
                            from the Greek word for "snail" due to its
                            distinctive coiled shape. The cochlea contains
                            numerous sensory cells, referred to as "hair cells,"
                            and is linked to the central hearing system via the
                            auditory nerve. Within the cochlea, special fluids
                            play a vital role in the hearing process.
                          </p>
                        </li>
                      </ul>
                      <p>
                        Explore the below diagram to learn about each part of
                        the ear:
                      </p>
                      <div className="position-relative">
                        <div className="d-block">
                          <img
                            className="w-100"
                            src={require("../assets/ohs/images/noise-img/img3.png")}
                            alt="img"
                          />
                        </div>
                        {!dot1 ? (
                          <div
                            className="onclick-dot bg-red"
                            onClick={() => bodypart("1")}
                          >
                            <i className="fas fa-exclamation"></i>
                          </div>
                        ) : (
                          <div
                            className="onclick-dot  active-red "
                            onClick={() => bodypart("1")}
                          >
                            <i className="fas fa-exclamation"></i>
                          </div>
                        )}
                        {!dot2 ? (
                          <div
                            class="onclick-dot1 bg-red"
                            onClick={() => bodypart("2")}
                          >
                            <i class="fas fa-exclamation"></i>
                          </div>
                        ) : (
                          <div
                            class="onclick-dot1 active-red"
                            onClick={() => bodypart("2")}
                          >
                            <i class="fas fa-exclamation"></i>
                          </div>
                        )}
                        {!dot3 ? (
                          <div
                            className="onclick-dot2 bg-red"
                            onClick={() => bodypart("3")}
                          >
                            <i className="fas fa-exclamation"></i>
                          </div>
                        ) : (
                          <div
                            className="onclick-dot2 active-red"
                            onClick={() => bodypart("3")}
                          >
                            <i className="fas fa-exclamation"></i>
                          </div>
                        )}
                        {section3_content && (
                          <div className="safe-info4 d-block">
                            <div className="safe-please position-relative d-flex flex-column  gap-3">
                              <div className="d-flex justify-content-between ">
                                <h5>{title3}</h5>
                              </div>
                              <p>{param3}</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="d-block padding btn-block text-center">
                      <button type="button" onClick={() => nextstep("3")}>
                        CONTINUE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson4 && (
            <section id="noise" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={forth}
                  onClick={() => backlesson("4")}
                  to="#ear"
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson - 3 The Ear</h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 4 of 9</h4>
                      <h1>Noise-induced Hearing Loss(NIHL)</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>

                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <p>
                        Noise-induced hearing loss (NIHL) stems from extended
                        exposure to high levels of noise, commonly encountered
                        in noisy workplaces or during exposure to loud music.
                        Additionally, it can result from intense, abrupt sounds
                        like gunshots or explosions, which can inflict damage on
                        the structures within the ear.
                      </p>
                      <p>
                        When exposed to excessive noise, the delicate hairs
                        within the ear can sustain damage, often becoming
                        flattened by the sound. In cases of temporary hearing
                        damage, these hairs may recover; however, persistent
                        exposure or sudden, high-pressure sounds can lead to
                        irreversible damage.
                      </p>
                      <p>
                        The following images provide a microscopic perspective
                        of the hairs within the ear.
                      </p>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="d-block">
                            <img
                              className="w-100"
                              src={require("../assets/ohs/images/noise-img/img4.jpg")}
                              alt="img"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="d-block">
                            <img
                              className="w-100"
                              src={require("../assets/ohs/images/noise-img/img5.jpg")}
                              alt="img"
                            />
                          </div>
                        </div>
                      </div>
                      <h5>
                        What Measures Can I Take Regarding Noise-induced Hearing
                        Loss?
                      </h5>
                      <p>
                        Hearing aids can offer significant benefits by enhancing
                        your hearing in various everyday situations,
                        facilitating easier conversations, and potentially
                        reducing awareness of tinnitus. However, it's essential
                        to recognize that while hearing aids can improve your
                        hearing, they cannot fully restore it to normal. Thus,
                        it remains crucial to take preventive measures to avoid
                        hearing damage from noise exposure in the first place.
                      </p>
                      <h5>
                        Additionally, Identifying Noise-induced Hearing Loss
                      </h5>
                      <p>
                        Audiometric testing is a vital procedure for assessing
                        hearing levels, or audibility thresholds, in the ear.
                        This testing involves measuring an individual's response
                        to calibrated signal levels presented to the ear under
                        controlled conditions. Hearing loss resulting from noise
                        exposure often exhibits specific characteristics, such
                        as high-frequency loss, typically accompanied by a
                        distinctive "notch" shape in the audiogram.
                      </p>
                      <p>
                        Therefore, whether mandated by legislation or not,
                        incorporating audiometric testing into your health
                        monitoring program can significantly enhance your noise
                        management strategies.
                      </p>
                      <div className="row align-items-center ">
                        <div className="col-lg-6">
                          <div className="d-block">
                            <img
                              className="w-100"
                              src={require("../assets/ohs/images/noise-img/img6.jpg")}
                              alt="img"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="d-block">
                            <p>
                              In workplaces with high noise levels, conducting
                              audiometric testing on new employees helps
                              establish their baseline hearing levels prior to
                              commencing employment. Implementing a long-term,
                              routine audiometric testing program and screening
                              workers' hearing regularly also serves as a
                              valuable tool in identifying individuals most
                              susceptible to noise-induced hearing loss (NIHL).
                              However, it's important to note that individuals
                              may have already experienced some degree of
                              hearing loss by the time their susceptibility
                              becomes evident.
                            </p>
                            <p>
                              The primary advantage of a consistent audiometric
                              testing program lies in its ability to provide
                              early detection for workers displaying initial
                              signs of hearing impairment. This allows affected
                              individuals to promptly seek medical advice and,
                              if deemed appropriate, adopt additional measures
                              to safeguard their hearing against future noise
                              exposure.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-block padding btn-block text-center">
                      <button type="button" onClick={() => nextstep("4")}>
                        CONTINUE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson5 && (
            <section id="exposure" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={fifth}
                  onClick={() => backlesson("5")}
                  to="#noise"
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson - 4 Noise-induced Hearing Loss(NIHL)</h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 5 of 9</h4>
                      <h1>Noise Exposure Standards</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>

                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <p>
                        The primary standard pertains to daily exposure levels,
                        quantified as doses. These are time-weighted levels,
                        typically expressed as an 8-hour equivalent level and
                        are A-weighted. This adjustment accounts for the
                        frequency-dependent sensitivity of the human ear, making
                        these levels more representative of what the ear
                        perceives.
                      </p>
                      <p>
                        The secondary standard addresses the maximum sound
                        pressure level, also known as the peak noise level,
                        which workers should not exceed, set at 140 dB(C).
                      </p>
                      <table className="customTable ">
                        <thead>
                          <tr>
                            <th style={{ color: "#fff" }}>
                              <h3>Levels </h3>
                            </th>
                            <th style={{ color: "#fff" }}>
                              <h3>Exposure </h3>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <p> Exposure Standard </p>
                            </td>
                            <td>
                              <ul className="d-flex flex-column gap-3">
                                <li>
                                  <p>
                                    Equivalent 8-hour daily personal noise
                                    exposure of 85 dB (A)
                                  </p>
                                </li>
                                <li>
                                  <p>Peak sound pressure of 140 dB(C)</p>
                                </li>
                              </ul>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <h5>Action Required</h5>
                      <p>
                        As a general guideline, if it becomes necessary to shout
                        to be heard over a distance of approximately one meter,
                        it's advisable to conduct a noise assessment.
                      </p>
                      <p>
                        The following table outlines the necessary actions
                        corresponding to the exposure standard:
                      </p>
                      <table className="customTable customTable1">
                        <thead>
                          <tr>
                            <th style={{ color: "#fff" }}>
                              <h3>Action Required </h3>
                            </th>
                            <th style={{ color: "#fff" }}>
                              <h3>Exposure Standard </h3>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={{ textAlign: "left" }}>
                              <p>Risk assessment must be carried out </p>
                            </td>
                            <td>
                              <p>Yes</p>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: "left" }}>
                              <p>
                                Suitable and sufficient information,
                                instruction, and training for workers{" "}
                              </p>
                            </td>
                            <td>
                              <p>Yes</p>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: "left" }}>
                              <p>Elimination or control of exposure to noise</p>
                            </td>
                            <td>
                              <p>Yes</p>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: "left" }}>
                              <p>
                                All equipment provided to be fully maintained
                                and repaired{" "}
                              </p>
                            </td>
                            <td>
                              <p>Yes</p>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: "left" }}>
                              <p>
                                Compulsory provision of personal hearing
                                protection
                              </p>
                            </td>
                            <td>
                              <p>Yes</p>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: "left" }}>
                              <p>Establishment of hearing protection zones </p>
                            </td>
                            <td>
                              <p>Yes</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <p>
                        The table below illustrates the duration of exposure for
                        individuals without hearing protection before surpassing
                        the exposure standard (LAeq,8h = 85 dB(A)):
                      </p>
                      <table className="customTable ">
                        <thead>
                          <tr>
                            <th style={{ color: "#fff" }}>
                              <h3>Noise Level (dB(A)) </h3>
                            </th>
                            <th style={{ color: "#fff" }}>
                              <h3>
                                Exposure Time Before Standard Is Exceeded{" "}
                              </h3>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <p> 80 </p>
                            </td>
                            <td>
                              <p>16 hours</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p> 82 </p>
                            </td>
                            <td>
                              <p>12 hours</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p> 80 </p>
                            </td>
                            <td>
                              <p>16 hours</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p> 85 </p>
                            </td>
                            <td>
                              <p>8 hours</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p> 88 </p>
                            </td>
                            <td>
                              <p>4 hours</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>91 </p>
                            </td>
                            <td>
                              <p>2 hours</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p> 94 </p>
                            </td>
                            <td>
                              <p>1 hour</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>97 </p>
                            </td>
                            <td>
                              <p>30 minutes</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p> 100 </p>
                            </td>
                            <td>
                              <p>15 minutes</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>103 </p>
                            </td>
                            <td>
                              <p>7.5 minutes</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p> 106 </p>
                            </td>
                            <td>
                              <p>3.8 minutes</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>109 </p>
                            </td>
                            <td>
                              <p>1.9 minutes</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p> 112 </p>
                            </td>
                            <td>
                              <p>57 seconds</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p> 115 </p>
                            </td>
                            <td>
                              <p>28.8 seconds</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p> 118 </p>
                            </td>
                            <td>
                              <p>14.4 seconds</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>121 </p>
                            </td>
                            <td>
                              <p>7.2 seconds</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p> 124 </p>
                            </td>
                            <td>
                              <p>3.6 seconds</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>127 </p>
                            </td>
                            <td>
                              <p>1.8 seconds</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>130 </p>
                            </td>
                            <td>
                              <p>0.9 seconds</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <h5>Daily Personal Noise Exposure</h5>
                      <p>
                        The daily total personal exposure to noise at work is
                        determined by averaging the noise levels in the working
                        areas and the duration of exposure to the noise. This
                        calculated value is then standardized to an 8-hour day,
                        accommodating individuals whose working days vary in
                        length from the standard eight hours.
                      </p>
                      <div className="row align-items-center ">
                        <div className="col-lg-6">
                          <div className="d-block">
                            <img
                              className="w-100"
                              src={require("../assets/ohs/images/noise-img/img7.jpg")}
                              alt="img"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="d-flex flex-column gap-3">
                            <p>
                              To compute an individual's daily noise exposure
                              level, a comparable method can be applied to
                              analyze measurements gathered using personal
                              dosimeters worn by workers. These dosimeters
                              account for fluctuations in noise levels
                              experienced by workers over the measurement
                              period, which can then be standardized to reflect
                              an eight-hour exposure.
                            </p>
                            <p>
                              The objective of this assessment is to ascertain
                              the daily noise exposure level without protection,
                              enabling comparison with the exposure standard.
                              This comparison helps confirm the necessary
                              actions that the PCBU must undertake to safeguard
                              workers against noise exposure.
                            </p>
                          </div>
                        </div>
                      </div>
                      <h5>Exposure to Peak Noise</h5>
                      <p>
                        Peak sound pressure refers to the maximum pressure level
                        experienced at the ear, often occurring during sudden
                        impacts or when using equipment like a nail gun or a
                        cartridge-operated power tool. The Exposure Limit Value
                        (ELV) of 200Pa corresponds to a peak level of 140 dB(C).
                      </p>
                      <div className="row align-items-center ">
                        <div className="col-lg-6">
                          <div className="d-block">
                            <img
                              className="w-100"
                              src={require("../assets/ohs/images/noise-img/img8.jpg")}
                              alt="img"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="d-flex flex-column gap-3">
                            <p>
                              PCBUs typically focus on mitigating noise
                              exposures based on average noise levels or
                              dosimeter measurements throughout the workday.
                              However, it's crucial to note that workers may
                              occasionally encounter infrequent yet extremely
                              loud impulsive noises. These noise levels must
                              never surpass the Exposure Limit Value (ELV) under
                              any circumstances.
                            </p>
                          </div>
                        </div>
                      </div>
                      <p>Peak sound is classNameified into three types:</p>
                      <ul className="d-flex flex-column gap-3">
                        <li>
                          <p>Type 1: Low-frequency source.</p>
                        </li>
                        <li>
                          <p>Type 2: Medium to high-frequency source.</p>
                        </li>
                        <li>
                          <p>Type 3: High-frequency source.</p>
                        </li>
                      </ul>
                      <div className="d-block big-img">
                        <img
                          className="w-100 object-fit-contain h-100"
                          src={require("../assets/ohs/images/noise-img/task.png")}
                          alt="Task"
                        />
                      </div>
                      <h5>Other Effects of Noise</h5>
                      <p>
                        It's crucial to recognize that noise, even at levels
                        that don't cause hearing damage, can lead to other
                        detrimental health consequences. This occurs when noise
                        consistently disrupts concentration and communication.
                        Prolonged exposure to noise stress can elevate the risk
                        of fatigue and cardiovascular disorders, including
                        hypertension and heart disease.
                      </p>
                      <p>
                        While safe thresholds to prevent these effects haven't
                        been definitively established, as a general guideline,
                        minimizing noise levels below certain thresholds can
                        mitigate the risk of adverse health effects:
                      </p>
                      <ul className="d-flex flex-column gap-3">
                        <li>
                          <p>
                            50 dB(A) in settings requiring high concentration or
                            easy conversation.
                          </p>
                        </li>
                        <li>
                          <p>
                            70 dB(A) in environments where more routine work is
                            conducted, demanding speed or attentiveness, or
                            where maintaining conversations is essential.
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="d-block padding btn-block text-center">
                      <button type="button" onClick={() => nextstep("5")}>
                        CONTINUE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson6 && (
            <section id="levels" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={sixth}
                  onClick={() => backlesson("6")}
                  to="#exposure"
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson - 5 Noise Exposure Standards</h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 6 of 9</h4>
                      <h1>Assessment of Noise Levels</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>

                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <h5>Initial Evaluation of Noise Levels</h5>
                      <p>
                        The preliminary assessment stage aims to determine if
                        there's a potential issue, typically accomplished
                        through a straightforward test. If a problem is
                        detected, it's advisable to conduct a comprehensive risk
                        assessment to identify those at risk and determine
                        necessary protective measures.
                      </p>
                      <p>
                        Often, the need for a noise assessment can be determined
                        without conducting detailed noise measurements
                        initially. For instance, excessive and potentially
                        hazardous noise levels may be inferred in settings where
                        individuals must raise their voices to communicate or
                        experience difficulty hearing someone within
                        approximately one meter.
                      </p>
                      <table className="customTable ">
                        <thead>
                          <tr>
                            <th style={{ color: "#fff" }}>
                              <h3>Test</h3>
                            </th>
                            <th style={{ color: "#fff" }}>
                              <h3>Probable Noise Level (dB)</h3>
                            </th>
                            <th style={{ color: "#fff" }}>
                              <h3>
                                Risk Assessment Required for Exposure Greater
                                Than
                              </h3>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={{ textAlign: "left" }}>
                              <p>
                                Noise is intrusive but normal conversation is
                                possible{" "}
                              </p>
                            </td>
                            <td>
                              <p>80</p>
                            </td>
                            <td>
                              <p>6hrs</p>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ textAlign: "left" }}>
                              <p>
                                Shouting is necessary to communicate with
                                someone 1 meter away{" "}
                              </p>
                            </td>
                            <td>
                              <p>90</p>
                            </td>
                            <td>
                              <p>45 minutes</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <h5>Records of Assessment</h5>
                      <p>
                        PCBUs are obligated to maintain comprehensive records of
                        noise assessments. It is advisable to retain records of
                        each assessment for a reasonable duration to track
                        trends within an area and provide evidence of individual
                        exposure levels.
                      </p>
                      <p>The record should encompass the following details:</p>
                      <ul className="d-flex flex-column gap-3">
                        <li>
                          <p>
                            The workplaces, areas, tasks, and individuals
                            assessed.
                          </p>
                        </li>
                        <li>
                          <p>
                            Locations of noise measurements, duration of
                            measurements, and notes on any implemented noise
                            control measures during the assessment.
                          </p>
                        </li>
                        <li>
                          <p>
                            Description of ongoing work during measurements,
                            such as the process or materials being machined, or
                            the type of press tool in use.
                          </p>
                        </li>
                        <li>
                          <p>
                            Work patterns and calculations of daily exposure
                            based on these patterns.
                          </p>
                        </li>
                        <li>
                          <p>
                            All daily personal noise exposures (LAeq,8h) equal
                            to or exceeding the exposure standard.
                          </p>
                        </li>
                        <li>
                          <p>Peak noise exposure levels.</p>
                        </li>
                        <li>
                          <p>
                            Identification of noise sources contributing to
                            excessive noise levels.
                          </p>
                        </li>
                        <li>
                          <p>
                            Recommendations for measures to mitigate noise
                            exposure.
                          </p>
                        </li>
                        <li>
                          <p>
                            Dates and times of noise measurements underlying the
                            assessment.
                          </p>
                        </li>
                        <li>
                          <p>
                            Individuals responsible for conducting measurements
                            and assessments.
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="d-block padding btn-block text-center">
                      <button type="button" onClick={() => nextstep("6")}>
                        CONTINUE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson7 && (
            <section id="control" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={seven}
                  onClick={() => backlesson("7")}
                  to="#levels"
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson - 6 Assessment of Noise Levels</h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 7 of 9</h4>
                      <h1>Noise Control and Management </h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>

                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <h5>Hierarchy of Controls</h5>
                      <p>
                        Worker exposure to hazardous noise necessitates control
                        measures following the hierarchy of controls.
                      </p>
                      <p>
                        The most effective measure is to completely eliminate
                        the noise source. This can be achieved by discontinuing
                        the use of noisy machinery, altering work processes to
                        avoid generating hazardous noise, or preventing the
                        introduction of the hazard into the workplace.
                      </p>
                      <p>
                        If elimination isn't feasible, the risk must be
                        minimized as far as reasonably practicable.
                      </p>
                      <h5>Control of Noise at the Source</h5>
                      <p>
                        Machinery constitutes the primary source of noise
                        hazards in workplaces. Noise typically arises from the
                        movement and vibration of machine components and the
                        materials being processed. Upon identifying the noise
                        sources, priority should be given to addressing the
                        loudest components, followed by others in decreasing
                        order of magnitude. Possible interventions may include:
                      </p>
                      <div className="py-3 d-flex justify-content-center align-items-center bg-light">
                        <div
                          className="card1 card-1 p-0 shadow"
                          style={{ maxWidth: "100%" }}
                        >
                          <nav>
                            <div
                              className="nav nav-tabs mb-3 nav-fill"
                              id="nav-tab1"
                              role="tablist"
                            >
                              <button
                                className={`nav-link  ${Tab7_1 === "Tab1" ? "active " : ""
                                  } `}
                                id="nav-home-tab12"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-home12"
                                type="button"
                                role="tab"
                                aria-controls="nav-home"
                                aria-selected="true"
                                tabindex="-1"
                                onClick={() => tabsection7("Tab1")}
                              >
                                MACHINE DESIGN AND REPLACEMENT
                              </button>
                              <button
                                className={`nav-link  ${Tab7_2 === "Tab2" ? "active" : ""
                                  } `}
                                id="nav-profile-tab22"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-profile22"
                                type="button"
                                role="tab"
                                aria-controls="nav-profile"
                                aria-selected="false"
                                tabindex="-1"
                                onClick={() => tabsection7("Tab2")}
                              >
                                PLANNED MAINTENANCE
                              </button>
                              <button
                                className={`nav-link  ${Tab7_3 === "Tab3" ? "active" : ""
                                  } `}
                                id="nav-contact-tab22"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-contact22"
                                type="button"
                                role="tab"
                                aria-controls="nav-contact"
                                aria-selected="false"
                                tabindex="-1"
                                onClick={() => tabsection7("Tab3")}
                              >
                                SUBSTITUTION OF MACHINE
                              </button>
                              <button
                                className={`nav-link  ${Tab7_4 === "Tab4" ? "active " : ""
                                  } `}
                                id="nav-green-tab42"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-green42"
                                type="button"
                                role="tab"
                                aria-controls="nav-green4"
                                aria-selected="false"
                                tabindex="-1"
                                onClick={() => tabsection7("Tab4")}
                              >
                                VIBRATION ISOLATION AND DAMPING
                              </button>
                              <button
                                className={`nav-link  ${Tab7_5 === "Tab5" ? "active " : ""
                                  } `}
                                id="nav-red-tab22"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-red2"
                                type="button"
                                role="tab"
                                aria-controls="nav-red"
                                aria-selected="false"
                                tabindex="-1"
                                onClick={() => tabsection7("Tab5")}
                              >
                                REDUCING IMPACT NOICE
                              </button>
                              <button
                                className={`nav-link  ${Tab7_6 === "Tab6" ? "active " : ""
                                  } `}
                                id="nav-red-tab22"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-red22"
                                type="button"
                                role="tab"
                                aria-controls="nav-red"
                                aria-selected="false"
                                tabindex="-1"
                                onClick={() => tabsection7("Tab6")}
                              >
                                SILENCERS
                              </button>
                            </div>
                          </nav>
                          <div
                            className="tab-content p-4 bg-light"
                            id="nav-tabContent"
                          >
                            {Tab7_1 && (
                              <div
                                className="tab-pane fade active show"
                                id="nav-home12"
                                role="tabpanel"
                                aria-labelledby="nav-home-tab12"
                              >
                                <p>
                                  The best way to prevent noise is to consider
                                  the issue at the design stage. Often small
                                  changes in machine design or in the material
                                  used can result in a significant reduction in
                                  noise levels.
                                </p>
                                <p>
                                  All machinery supplied or put into service
                                  should be designed and constructed so as to
                                  minimise noise emissions to the lowest level
                                  possible, taking into account technical
                                  progress and the availability of means of
                                  reducing noise.
                                </p>
                                <div className="d-block w-100">
                                  <img
                                    src={require("../assets/ohs/images/noise-img/img9.jpg")}
                                    alt=""
                                  />
                                </div>
                              </div>
                            )}
                            {Tab7_2 && (
                              <div
                                className="tab-pane fade active show"
                                id="nav-profile22"
                                role="tabpanel"
                                aria-labelledby="nav-profile-tab22"
                              >
                                <p>
                                  Regular maintenance checks are crucial.
                                  Ensuring that worn or unbalanced machine parts
                                  are replaced or adjusted, lubricating machine
                                  components, tightening loose bolts, and using
                                  properly sharpened cutting tools can lead to a
                                  notable decrease in the sound level..
                                </p>
                                <div className="d-block">
                                  <img
                                    className="w-100"
                                    src={require("../assets/ohs/images/noise-img/img10.jpg")}
                                    alt=""
                                  />
                                </div>
                              </div>
                            )}
                            {Tab7_3 && (
                              <div
                                className="tab-pane fade active show"
                                id="nav-contact32"
                                role="tabpanel"
                                aria-labelledby="nav-contact-tab32"
                              >
                                <p>
                                  While substituting a noisy machine or process
                                  with a quieter alternative isn't always
                                  possible, adopting different work methods can
                                  sometimes circumvent the necessity for loud
                                  processes.
                                </p>
                                <p>Examples of substitution methods include:</p>
                                <ul className="d-flex flex-column gap-3">
                                  <li>
                                    <p>
                                      Utilizing hydraulic presses instead of
                                      mechanical presses.
                                    </p>
                                  </li>
                                  <li>
                                    <p>Opting for welding over riveting.</p>
                                  </li>
                                  <li>
                                    <p>
                                      Implementing belt drives in place of
                                      gears.
                                    </p>
                                  </li>
                                  <li>
                                    <p>Installing low-noise air-lines.</p>
                                  </li>
                                </ul>
                                <div className="d-block">
                                  <img
                                    className="w-100"
                                    src={require("../assets/ohs/images/noise-img/img11.jpg")}
                                    alt=""
                                  />
                                </div>
                              </div>
                            )}
                            {Tab7_4 && (
                              <div
                                className="tab-pane fade active show"
                                id="nav-green42"
                                role="tabpanel"
                                aria-labelledby="nav-green-tab42"
                              >
                                <p>
                                  A metal panel, when forced into vibration by a
                                  machine to which it's attached, can emit high
                                  noise levels, especially when vibrating at its
                                  natural frequency. Resonance can be prevented
                                  by altering its frequency, achievable through
                                  the following methods:
                                </p>
                                <ul className="d-flex flex-column gap-3">
                                  <li>
                                    <p>
                                      Increasing the stiffness of the panel.
                                    </p>
                                  </li>
                                  <li>
                                    <p>Incorporating damping material.</p>
                                  </li>
                                  <li>
                                    <p>
                                      Augmenting the mass of the vibrating
                                      panel.
                                    </p>
                                  </li>
                                </ul>
                                <p>
                                  For optimal effectiveness, the damping
                                  material should be heavier than the panel and
                                  ideally adhered with glue rather than screws
                                  or fasteners. Additionally, machine
                                  anti-vibration mountings can be utilized to
                                  isolate the machine and minimize the
                                  transmission of vibrations to floors and
                                  walls. These mountings are commonly employed
                                  with engines, compressors, and ventilating
                                  fans.
                                </p>
                                <div className="d-block">
                                  <img
                                    className="w-100"
                                    src={require("../assets/ohs/images/noise-img/img12.jpg")}
                                    alt=""
                                  />
                                </div>
                              </div>
                            )}
                            {Tab7_5 && (
                              <div
                                className="tab-pane fade active show"
                                id="nav-red2"
                                role="tabpanel"
                                aria-labelledby="nav-red-tab2"
                              >
                                <p>
                                  In cases where noise is generated by impact,
                                  it may be possible to diminish it by employing
                                  impact-absorbing materials. Utilizing
                                  heavy-duty rubber or neoprene between
                                  impacting surfaces is one approach. For
                                  instance, when metal objects or scrap metals
                                  fall into a metal bin, placing these materials
                                  between the surfaces can help mitigate noise.
                                </p>
                                <p>
                                  Other strategies include lining the bin with
                                  rubber or substituting it with a perforated
                                  metal container. Additionally, reducing the
                                  drop height of articles or implementing
                                  measures to break their fall can be effective.
                                  Conveyor systems can also be designed to
                                  prevent components being transported from
                                  rattling against each other, thus reducing
                                  noise levels.
                                </p>
                                <div className="d-block">
                                  <img
                                    className="w-100"
                                    src={require("../assets/ohs/images/noise-img/img13.jpg")}
                                    alt=""
                                  />
                                </div>
                              </div>
                            )}
                            {Tab7_6 && (
                              <div
                                className="tab-pane fade active show"
                                id="nav-red22"
                                role="tabpanel"
                                aria-labelledby="nav-red-tab22"
                              >
                                <p>
                                  A silencer serves as a device engineered to
                                  mitigate noise across various frequencies.
                                  These devices are installed within ductwork or
                                  pipework connected to fans, pumps, or
                                  compressors to diminish the transmission of
                                  noise originating from turbulent air or liquid
                                  flows. Importantly, they achieve this
                                  reduction without impeding the movement of the
                                  gas or fluid.
                                </p>

                                <div className="d-block">
                                  <img
                                    className="w-100"
                                    src={require("../assets/ohs/images/noise-img/img14.jpg")}
                                    alt=""
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <h5>Noise Path Control</h5>
                      <p>
                        Once noise exposure has been reasonably controlled at
                        its source, the subsequent objective is to minimize the
                        transmission of acoustic energy from the source to the
                        receiver. Examples of methods to achieve this include:
                      </p>
                      <div className="py-3 d-flex justify-content-center align-items-center bg-light">
                        <div
                          className="card1 card-1 p-0 shadow"
                          style={{ maxWidth: "100%" }}
                        >
                          <nav>
                            <div
                              className="nav nav-tabs mb-3 nav-fill"
                              id="nav-tab1"
                              role="tablist"
                            >
                              <button
                                className={`nav-link  ${Tab77_1 === "Tab1" ? "active " : ""
                                  } `}
                                id="nav-home-tab123"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-home123"
                                type="button"
                                role="tab"
                                aria-controls="nav-home"
                                aria-selected="true"
                                tabindex="-1"
                                onClick={() => tabsection7_3("Tab1")}
                              >
                                TOTAL OR PARTIAL ENCLOSURE
                              </button>
                              <button
                                className={`nav-link  ${Tab77_2 === "Tab2" ? "active " : ""
                                  } `}
                                id="nav-profile-tab223"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-profile223"
                                type="button"
                                role="tab"
                                aria-controls="nav-profile"
                                aria-selected="false"
                                tabindex="-1"
                                onClick={() => tabsection7_3("Tab2")}
                              >
                                INCREASING THE DISTANCE
                              </button>
                              <button
                                className={`nav-link  ${Tab77_3 === "Tab3" ? "active " : ""
                                  } `}
                                id="nav-contact-tab323"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-contact323"
                                type="button"
                                role="tab"
                                aria-controls="nav-contact"
                                aria-selected="false"
                                tabindex="-1"
                                onClick={() => tabsection7_3("Tab3")}
                              >
                                REDUCING THE EXPOSURE TIME
                              </button>
                            </div>
                          </nav>
                          <div
                            className="tab-content p-4 bg-light"
                            id="nav-tabContent"
                          >
                            {Tab77_1 && (
                              <div
                                className="tab-pane fade active show"
                                id="nav-home123"
                                role="tabpanel"
                                aria-labelledby="nav-home-tab123"
                              >
                                <p>
                                  A standard enclosure might consist of panels
                                  equipped with airtight seals and feature an
                                  inner lining of sound-absorbing material.
                                  However, the level of noise reduction achieved
                                  practically hinges largely on safety and
                                  operational factors.
                                </p>
                                <p>
                                  Examples of such considerations encompass:
                                </p>
                                <ul className="d-flex flex-column gap-3">
                                  <li>
                                    <p>
                                      Temperature, light, and ventilation needs.
                                    </p>
                                  </li>
                                  <li>
                                    <p>Material movement requirements.</p>
                                  </li>
                                  <li>
                                    <p>
                                      Provision of operator access and space for
                                      movement.
                                    </p>
                                  </li>
                                  <li>
                                    <p>Incorporation of observation windows.</p>
                                  </li>
                                  <li>
                                    <p>
                                      Management of ducts and pipes penetrating
                                      the enclosure.
                                    </p>
                                  </li>
                                </ul>

                                <div className="d-block big-img">
                                  <img
                                    className="w-100 h-100 object-fit-contain "
                                    src={require("../assets/ohs/images/noise-img/img15.jpg")}
                                    alt=""
                                  />
                                </div>
                              </div>
                            )}
                            {Tab77_2 && (
                              <div
                                className="tab-pane fade active show"
                                id="nav-profile223"
                                role="tabpanel"
                                aria-labelledby="nav-profile-tab223"
                              >
                                <p>
                                  For every doubling of the distance from the
                                  noise source, the noise level diminishes by 6
                                  dB. For instance, if the noise level measures
                                  90 dB at a distance of 0.5 meters from the
                                  source, it will decrease to 84 dB when the
                                  distance is extended to one meter.
                                  Consequently, increasing the distance from the
                                  source can significantly lower the noise
                                  level.
                                </p>
                                <p>
                                  Nevertheless, the practical application of
                                  this control measure is constrained by factors
                                  such as the nature of the task being
                                  performed, the influence of other nearby noise
                                  sources, and the presence of reverberant noise
                                  components.
                                </p>
                              </div>
                            )}
                            {Tab77_3 && (
                              <div
                                className="tab-pane fade show active "
                                id="nav-contact323"
                                role="tabpanel"
                                aria-labelledby="nav-contact-tab323"
                              >
                                <p>
                                  When the sound level exceeds 85 dB(A),
                                  maintaining the daily personal noise exposure
                                  (LAeq,8h) below 85 dB(A) is achievable by
                                  reducing the exposure duration. This can be
                                  accomplished through job rotation. For
                                  instance, exposure to 88 dB(A) for four hours
                                  or even 91 dB(A) for one hour is acceptable,
                                  provided that the rest of the shift is spent
                                  in a quieter environment registering less than
                                  80 dB(A).
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <h5>
                        Control at the Receiver — Provision of Hearing
                        Protection
                      </h5>
                      <p>
                        Hearing protection should be utilized solely under the
                        following circumstances:
                      </p>
                      <div className="row align-items-center ">
                        <div className="col-lg-6">
                          <div className="d-block">
                            <img
                              className="w-100"
                              src={require("../assets/ohs/images/noise-img/img16.jpg")}
                              alt="img"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="d-block">
                            <ul className="d-flex flex-column gap-3">
                              <li>
                                <p>
                                  As a final option, hearing protection should
                                  be employed if other noise control measures
                                  have proven ineffective in lowering the noise
                                  level below the standard of 85 dB(A).
                                </p>
                              </li>
                              <li>
                                <p>
                                  In high-noise environments, such as a plant
                                  room accessed infrequently or for brief
                                  durations.
                                </p>
                              </li>
                              <li>
                                <p>
                                  For immediate safeguarding in cases where a
                                  noise issue has been identified, pending
                                  implementation of longer-term solutions.
                                </p>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <h5>Hearing Protection Zones</h5>
                      <div className="row align-items-center ">
                        <div className="col-lg-6">
                          <div className="d-block">
                            <img
                              className="w-100"
                              src={require("../assets/ohs/images/noise-img/img17.jpg")}
                              alt="img"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="d-flex flex-column gap-3">
                            <p>
                              It is imperative to designate "Hearing Protection
                              Zones" during the workplace noise assessment.
                            </p>
                            <p>
                              Clear warning signs must be prominently displayed
                              at all entrances to these zones and at various
                              points within the designated areas.
                            </p>
                            <p>
                              These signs serve as a directive for workers to
                              wear personal ear protectors while inside the
                              zone.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-block padding btn-block text-center">
                      <button type="button" onClick={() => nextstep("7")}>
                        CONTINUE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson8 && (
            <section id="personal" className="intro w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={eight}
                  onClick={() => backlesson("8")}
                  to="#control"
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson - 7 Noise Control and Management</h5>
                </Link>
                <div className="stop fixnav">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 8 of 9</h4>
                      <h1>Personal Protective Equipment</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>

                  <div className="col-lg-10 offset-md-1">
                    <div
                      id="legal"
                      className="d-flex flex-column padding gap-3 py-3 py-md-5 introdu"
                    >
                      <p>
                        The primary varieties of personal hearing protection
                        include:
                      </p>

                      <div className="d-flex flex-md-row flex-column   gy-3 gap-3 justify-content-sm-between justify-content-center align-items-center ">
                        <div className="scene scene--card">
                          <div className="card">
                            {!eight1 && (
                              <div
                                className="card__face card__face--front"
                                onClick={() => section8("1")}
                              >
                                <div className="d-block">
                                  <img
                                    className="w-100"
                                    src={require("../assets/ohs/images/noise-img/img18.jpg")}
                                    alt="png"
                                  />
                                </div>
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  data-bs-toggle="tooltip"
                                  data-bs-title="Click to flip"
                                >
                                  <i className="far fa-sync-alt"></i>
                                </button>
                              </div>
                            )}
                            {eight1 && (
                              <div
                                className="card__face card__face--back"
                                onClick={() => section8("1")}
                              >
                                Earmuffs (ear defenders)
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="scene scene--card">
                          <div className="card ">
                            {!eight2 && (
                              <div
                                className="card__face card__face--front"
                                onClick={() => section8("2")}
                              >
                                <div className="d-block">
                                  <img
                                    className="w-100"
                                    src={require("../assets/ohs/images/noise-img/img19.jpg")}
                                    alt="png"
                                  />
                                </div>
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  data-bs-toggle="tooltip"
                                  data-bs-title="Click to flip"
                                >
                                  <i className="far fa-sync-alt"></i>
                                </button>
                              </div>
                            )}
                            {eight2 && (
                              <div
                                className="card__face card__face--back"
                                onClick={() => section8("2")}
                              >
                                <div className="d-flex flex-column ">
                                  <p>Earplugs</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="scene scene--card">
                          <div className="card">
                            {!eight3 && (
                              <div
                                className="card__face card__face--front"
                                onClick={() => section8("3")}
                              >
                                <div className="d-block px-4">
                                  <img
                                    className="w-100"
                                    src={require("../assets/ohs/images/noise-img/img20.jpg")}
                                    alt="png"
                                  />
                                </div>
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  data-bs-toggle="tooltip"
                                  data-bs-title="Click to flip"
                                >
                                  <i className="far fa-sync-alt"></i>
                                </button>
                              </div>
                            )}
                            {eight3 && (
                              <div
                                className="card__face card__face--back"
                                onClick={() => section8("3")}
                              >
                                <div className="d-flex flex-column ">
                                  <p> Semi-inserts (moulded)</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <p>
                        Hearing protectors are intended to diminish the noise
                        reaching the ear by attenuating noise across different
                        frequencies, offering various levels of attenuation.
                        Hence, careful selection is crucial to ensure
                        suitability for specific applications. For instance,
                        hearing protection designed for high-frequency noise may
                        not effectively protect against low-frequency noise.
                      </p>
                      <p>
                        The chosen hearing protection must reduce the worker's
                        noise exposure below the established standards.
                        Additionally, it should be compatible with any other
                        required personal protective equipment in the workplace.
                      </p>
                      <h5>Training</h5>
                      <p>
                        It is vital to provide workers with training on how to
                        properly fit and use hearing protection, store them
                        correctly, and maintain them in good condition.
                        Suppliers of hearing protection can offer assistance in
                        selecting the most suitable options for the PCBUs'
                        requirements and may also provide training support.
                      </p>
                      <h5>How to Fit Your Earplugs</h5>
                      <p>
                        The following instructional video clip by 3M can be
                        applied to the fitting of all brands of roll-down
                        earplugs.
                      </p>
                      <div className="yt-video d-block">
                        <figure
                          aria-hidden="false"
                          aria-label="Embedded media player"
                          className="embed__media-wrap"
                          tabindex="0"
                        >
                          <iframe
                            className="embed__media"
                            src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fwww.youtube.com%2Fembed%2FkMMHudYoQ40%3Ffeature%3Doembed&amp;url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DkMMHudYoQ40&amp;image=https%3A%2F%2Fi.ytimg.com%2Fvi%2FkMMHudYoQ40%2Fhqdefault.jpg&amp;key=40cb30655a7f4a46adaaf18efb05db21&amp;type=text%2Fhtml&amp;schema=youtube"
                            alt="How to fit your 3M roll down earplugs"
                            frameborder="0"
                            scrolling="no"
                            allowfullscreen=""
                            title="How to fit your 3M roll down earplugs"
                          ></iframe>
                        </figure>
                      </div>
                      <h5>
                        Learn the Proper Technique for Fitting Your 3M Roll Down
                        Earplugs
                      </h5>
                      <p>
                        In this instructional video by 3M Personal Safety,
                        you'll discover the correct procedure for inserting
                        roll-down earplugs. It's essential to watch this video
                        to ensure you're fitting your roll-down earplugs
                        accurately, as an improper fit may diminish their
                        ability to attenuate noise effectively. Watch the video
                        on YouTube for detailed guidance.
                      </p>
                    </div>
                    <div className="d-block padding btn-block text-center">
                      <button type="button" onClick={() => nextstep("8")}>
                        CONTINUE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson9 && (
            <section id="assessment" className="human w-100">
              <div className="d-flex flex-column">
                <Link
                  to="#respond"
                  onClick={() => backlesson("9")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 8 - Personal Protective Equipment</h5>
                </Link>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 9 of 9</h4>
                      <h1>Final Assessment</h1>
                      <div className="line" style={{ width: "100%" }}></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <form action="javascript:void(0)">
                    <div className="col-lg-10 offset-md-1 padding py-5">
                      {sec_1 && (
                        <div className="d-flex flex-column gap-5 fullname-block text-center py-5">
                          <h4>
                            Please enter your FULL NAME before you continue:
                          </h4>
                          <div className="d-flex justify-content-center name-form">
                            <div className="d-flex gap-2">
                              <div className="flex-grow-1">
                                <input
                                  type="text"
                                  name=""
                                  id=""
                                  required
                                  onInput={entername_9}
                                  ref={inputRef}
                                  placeholder="Type your name here..."
                                />
                              </div>
                              <div className="flex-shrink-0">
                                <button type="submit" onClick={btn_entername}>
                                  Continue
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {quizless_9_1 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>How is noise measured?</h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_9 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q1"
                                  id="Lux"
                                  checked={checkQ_9_1 === "Lux"}
                                  onChange={() => startQuiz_9_1("Lux")}
                                />
                                {isfirstquiz_9_1 &&
                                  (issetQuizAns_9_1_btn === "Lux" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Lux">
                                Lux
                              </label>
                            </div>

                            <div
                              className={`form-check ${isOpacity_9 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q1"
                                  id="Pascals"
                                  checked={checkQ_9_1 === "Pascals"}
                                  onChange={() => startQuiz_9_1("Pascals")}
                                />
                                {isfirstquiz_9_1 &&
                                  (issetQuizAns_9_1_btn === "Pascals" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Pascals">
                                Pascals
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q1"
                                  id="Decibels"
                                  checked={checkQ_9_1 === "Decibels"}
                                  onChange={() => startQuiz_9_1("Decibels")}
                                />
                                {isfirstquiz_9_1 &&
                                  (issetQuizAns_9_1_btn === "Decibels" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Decibels"
                              >
                                Decibels
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q1"
                                  id="Newtons"
                                  checked={checkQ_9_1 === "Newtons"}
                                  onChange={() => startQuiz_9_1("Newtons")}
                                />
                                {isfirstquiz_9_1 &&
                                  (issetQuizAns_9_1_btn === "Newtons" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Newtons">
                                Newtons
                              </label>
                            </div>

                            {worngansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q1_9_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_9("1")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_1_9 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_9("1")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_9_2 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>What does this health and safety sign mean?</h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check  ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q2"
                                  id="Very noisy area ahead"
                                  checked={
                                    checkQ_9_2 === "Very noisy area ahead"
                                  }
                                  onChange={() =>
                                    startQuiz_9_2("Very noisy area ahead")
                                  }
                                />
                                {isfirstquiz_9_2 &&
                                  (issetQuizAns_9_2_btn ===
                                    "Very noisy area ahead" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Very noisy area ahead"
                              >
                                Very noisy area ahead
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q2"
                                  id="Hearing"
                                  checked={checkQ_9_2 === "Hearing"}
                                  onChange={() => startQuiz_9_2("Hearing")}
                                />
                                {isfirstquiz_9_2 &&
                                  (issetQuizAns_9_2_btn === "Hearing" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Hearing">
                                Hearing protection recommended but not
                                compulsory
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q2"
                                  id="Hearing protection"
                                  checked={checkQ_9_2 === "Hearing protection"}
                                  onChange={() =>
                                    startQuiz_9_2("Hearing protection")
                                  }
                                />
                                {isfirstquiz_9_2 &&
                                  (issetQuizAns_9_2_btn ===
                                    "Hearing protection" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Hearing protection"
                              >
                                Hearing protection must be warn
                              </label>
                            </div>

                            {worngansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q2_9_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_9("2")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_2_9 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_9("2")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_9_3 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>By wearing hearing protection you will:</h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="Reduce"
                                  checked={checkQ_9_3 === "Reduce"}
                                  onChange={() => startQuiz_9_3("Reduce")}
                                />
                                {isfirstquiz_9_3 &&
                                  (issetQuizAns_9_3_btn === "Reduce" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Reduce">
                                Reduce the amount of noise you are exposed to
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="Eliminate"
                                  checked={checkQ_9_3 === "Eliminate"}
                                  onChange={() => startQuiz_9_3("Eliminate")}
                                />
                                {isfirstquiz_9_3 &&
                                  (issetQuizAns_9_3_btn === "Eliminate" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Eliminate"
                              >
                                Eliminate all possibilities of being exposed to
                                excess noise levels
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="Reverse"
                                  checked={checkQ_9_3 === "Reverse"}
                                  onChange={() => startQuiz_9_3("Reverse")}
                                />
                                {isfirstquiz_9_3 &&
                                  (issetQuizAns_9_3_btn === "Reverse" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Reverse">
                                Reverse any previous hearing problems
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="Improve"
                                  checked={checkQ_9_3 === "Improve"}
                                  onChange={() => startQuiz_9_3("Improve")}
                                />
                                {isfirstquiz_9_3 &&
                                  (issetQuizAns_9_3_btn === "Improve" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Improve">
                                Improve your hearing
                              </label>
                            </div>
                            {worngansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q3_9_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_9("3")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_3_9 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_9("3")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_9_4 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>
                            When working in a 'hearing protection zone', you
                            must:
                          </h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q4"
                                  id="Be careful"
                                  checked={checkQ_9_4 === "Be careful"}
                                  onChange={() => startQuiz_9_4("Be careful")}
                                />
                                {isfirstquiz_9_4 &&
                                  (issetQuizAns_9_4_btn === "Be careful" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Be careful"
                              >
                                Be careful not to make excess noise
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q4"
                                  id="Have"
                                  checked={checkQ_9_4 === "Have"}
                                  onChange={() => startQuiz_9_4("Have")}
                                />
                                {isfirstquiz_9_4 &&
                                  (issetQuizAns_9_4_btn === "Have" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Have">
                                Have adequate hearing protection in-case you
                                need it
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q4"
                                  id="Wear"
                                  checked={checkQ_9_4 === "Wear"}
                                  onChange={() => startQuiz_9_4("Wear")}
                                />
                                {isfirstquiz_9_4 &&
                                  (issetQuizAns_9_4_btn === "Wear" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Wear">
                                Wear the appropriate hearing protection at all
                                times
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q4"
                                  id="Use"
                                  checked={checkQ_9_4 === "Use"}
                                  onChange={() => startQuiz_9_4("Use")}
                                />
                                {isfirstquiz_9_4 &&
                                  (issetQuizAns_9_4_btn === "Use" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Use">
                                Use hearing protection when the noises are too
                                loud to stand
                              </label>
                            </div>
                            {worngansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q4_9_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_9("4")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_4_9 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_9("4")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_9_5 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>
                            Over time, excess noise can damage your hearing.
                            Which of the following is an early sign of this?
                          </h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="A rash"
                                  checked={checkQ_9_5 === "A rash"}
                                  onChange={() => startQuiz_9_5("A rash")}
                                />
                                {isfirstquiz_9_5 &&
                                  (issetQuizAns_9_5_btn === "A rash" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="A rash">
                                A rash may appear around the outside of your ear
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="There"
                                  checked={checkQ_9_5 === "There"}
                                  onChange={() => startQuiz_9_5("There")}
                                />
                                {isfirstquiz_9_5 &&
                                  (issetQuizAns_9_5_btn === "There" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="There">
                                There are no early signs
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="A ringing"
                                  checked={checkQ_9_5 === "A ringing"}
                                  onChange={() => startQuiz_9_5("A ringing")}
                                />
                                {isfirstquiz_9_5 &&
                                  (issetQuizAns_9_5_btn === "A ringing" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="A ringing"
                              >
                                A ringing sound or even a temporary hearing loss
                                may occur
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_9_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="Infections"
                                  checked={checkQ_9_5 === "Infections"}
                                  onChange={() => startQuiz_9_5("Infections")}
                                />
                                {isfirstquiz_9_5 &&
                                  (issetQuizAns_9_5_btn === "Infections" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Infections"
                              >
                                Infections of the inner ear Dispose of it and
                                carry on working without one
                              </label>
                            </div>
                            {worngansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_9_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q5_9_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next_9("5")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_5_9 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_9("5")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {less_5_finresult && (
                        <div className="d-flex flex-column gap-3 text-center results-block">
                          <h3 className="text-danger">Results</h3>

                          <div className="row gy-3 gy-md-5">
                            <div className="col-lg-9">
                              <h3>
                                <b>Your Score:</b>
                              </h3>
                            </div>
                            <div className="col-lg-9">
                              <h3>
                                {score__per5}% ({score_5} points)
                              </h3>
                            </div>
                            <div className="col-lg-9">
                              <h3>
                                <b>Passing Score:</b>
                              </h3>
                            </div>
                            <div className="col-lg-9">
                              <h3>80% (40 points)</h3>
                            </div>
                            <div className="col-12">
                              {!corrScore && (
                                <h4 className="text-danger">
                                  <i className="far fa-times"></i> You did not
                                  pass
                                </h4>
                              )}
                              {corrScore && (
                                <h4 className="text-success">
                                  <i className="far fa-check check"></i> You
                                  pass
                                </h4>
                              )}
                            </div>
                            {!corrScore ? (
                              <div className="col-lg-">
                                <button type="button" onClick={refreshbtn}>
                                  Retry Assessment
                                </button>
                              </div>
                            ) : (
                              <div className="col-lg-">
                                <button type="button" onClick={downloadpdf}>
                                  Download
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </section>
          )}
        </div>
      </div>
    </>
  );
};
